<template>
    <div class="chat-window">
        <div class="messages" ref="messages" @scroll="updateFollowState">
            <div v-for="(message,index) in messages" :key="index">
                <UserMessage v-if="message.role === 'user'" :message="message"/>
                <AnalysisCard v-else :message="message"/>
            </div>
            <TypingIndicator v-if="loading"/>
        </div>
        <ChatInput @send="sendMessage" :loading="loading"/>
    </div>
</template>

<script>
import UserMessage from "./UserMessage.vue";
import AnalysisCard from "./AnalysisCard.vue";
import ChatMessage from "./ChatMessage.vue";
import ChatInput from "./ChatInput.vue";
import TypingIndicator from "./TypingIndicator.vue";

import chatService from "@/services/chatService";

export default {
    components:{
        ChatMessage,
        ChatInput,
        TypingIndicator,
        UserMessage,
        AnalysisCard
    },
    data(){
        return{
            loading:false,
            followConversation: true,
            programmaticScroll: false,
            messages:[{
                    role:"assistant",
                    content:"Salut!\n\n T'as lu un truc pas clair en ligne et t'aimerais savoir comment on peut le situer sur le fascistogramme? Donne moi le discours et on regarde ensemble!"
                }
            ]
        }
    },
    methods:{
        async sendMessage(text){
            let id = null;
            this.messages.push({
                role:"user",
                content:text
            });
            this.loading = true;
            this.followConversation = true;
            this.scrollBottomSmooth();

            try{
                const response= await chatService.sendMessage(text);
                id = response.discoursId;
                const index = this.messages.push({
                    role: "assistant",
                    content: ""
                }) - 1;
                await this.typeWriter(index, response.response);
            }
            catch(e){
                this.messages.push({
                role:"assistant",
                content:"Une erreur est survenue."
                });
            }
            this.loading=false;
            if (id != null) {
                this.pollDimensions(id);
            }
            this.scrollBottom();
        },
        updateFollowState() {
            if (this.programmaticScroll) return;
            const div = this.$refs.messages;
            const distance = div.scrollHeight - div.scrollTop - div.clientHeight;
            this.followConversation = distance < 3;
        },
        async pollDimensions(id){
            const timer = setInterval(async ()=>{
                const dimensions = await chatService.getDimensions(id);
                if(dimensions.length>0){
                    this.$emit("dimensions", dimensions);
                    clearInterval(timer);
                }
            },1000);
        },

        scrollBottom() {
            this.$nextTick(() => {
                this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
            });
        },

        scrollBottomSmooth() {
            this.$nextTick(() => {
                this.$refs.messages.scrollTo({
                    top: this.$refs.messages.scrollHeight,
                    behavior: "smooth"
                });
            });
        },

        async typeWriter(index, text) {
            const words = text.split(" ");

            for (const word of words) {
                this.messages[index].content += word + " ";
                await this.$nextTick();

                if (this.followConversation) {
                    this.programmaticScroll = true;
                    this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;

                    requestAnimationFrame(() => {
                        this.programmaticScroll = false;
                    });
                }
                await new Promise(resolve => setTimeout(resolve, 35));
            }
        }
    }
}
</script>
  
<style scoped>
.chat-window{
    display:flex;
    flex-direction:column;
    align-content: flex-start;
    height: 100%;
    min-height:0;
    margin:auto;
    padding:20px 24px;
}

.header{
    flex:0 0 auto;
    border-bottom:1px solid #262626;
    backdrop-filter:blur(15px);
    background:rgba(17,19,21,.85);
    max-height: 20%;
}

.header h1{
    margin:0;
    color:white;
    font-weight:700;
    letter-spacing:-1px;
    font-size: 20;
}

.header p{
    color:#9ca3af;
    margin-top:8px;
    font-size:15px;
}

.messages{
    flex:1 1 auto;
    overflow:auto;
    overflow-y: auto;
    min-height: 0;
}

.messages::-webkit-scrollbar{
    width:8px;
}

.messages::-webkit-scrollbar-thumb{
    background:#333;
    border-radius:20px;
}

.messages::-webkit-scrollbar-track{
    background:transparent;
    border-bottom:1px solid #262626;
    backdrop-filter:blur(15px);
    background:rgba(17,19,21,.85);
    position:sticky;
    top:0;
    z-index:20;
}
</style>